import styled from "styled-components"
import { Heart } from "styled-icons/icomoon/Heart"
import { Code } from "styled-icons/fa-solid/Code"

export const Wrapper = styled.footer`
  position: fixed;
  margin-top: auto;
  padding: 1rem;
  width: 100%;
  bottom: 0;
  box-shadow: 0 -3px 26px rgba(0, 0, 0, 0.5);
  background: linear-gradient(45deg, #04d361 0%, #00c853  100%);
  font-family: font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: 500;
  a:hover {
    color: #000;
  }
  @media only screen and (min-width: 480px) {
    br {
      display: none;
    }
  }
`

export const Text = styled.div`
  margin: 0;
  text-align: center;
  color: #fff;
  font-weight: 700;
  a {
    text-decoration: none;
    &:hover {
      color: #00c853;
    }
  }
  span {
    background-color: #222;
    padding: 0.5rem 1rem;
    border-radius: 15px;
    margin: 0.5rem;
  }
`

export const HeartIcon = styled(Heart)`
  width: 20px;
  :hover {
    color: red;
  }
`
export const CodeIcon = styled(Code)`
  width: 25px;
  :hover {
    color: #00c853;
  }
`
